module.exports = __webpack_public_path__ + "static/privacy-2-5c5c1139c149062062b1e765d081e221.svg";